import React from 'react';

import { useTranslation } from 'react-i18next';

import { bemCssModules, getTestId } from '@utils';
import { useNavigate } from '@utils/hooks';

import { useStore } from '@modules';
import { IbanStatusesEnum } from '@modules/user/types';

import ModalLayoutOld from '@layouts/ModalLayoutOld';

import style from './AccountTopupLayoutOld.scss';

const cn = bemCssModules(style, 'AccountTopupLayoutOld');
const ti = getTestId('AccountTopupLayoutOld');

const { created } = IbanStatusesEnum;

const AccountTopupLayoutOld: CustomFC = ({ className, children }) => {
  const { t } = useTranslation();

  const navigate = useNavigate();
  const [{ user }] = useStore();
  const { data } = user;
  const isIbanCreated = data?.iban_status === created;

  const tabs = [
    {
      label: t('iban.menu_topup_via_bank_account'),
      link: CONST.nav.accountsTopup,
      badge: 'SEPA',
      hidden: !isIbanCreated,
      end: true,
    },
    {
      label: t('iban.menu_my_wallets'),
      link: CONST.nav.accountsTopupWalletsExchange,
    },
  ];

  const onClose = () => navigate(CONST.nav.accounts);

  return (
    <ModalLayoutOld
      className={cn(null, [className])}
      data-testid={ti()}
      tabs={tabs}
      closeButton={onClose}
      accountsExclamation
    >
      {children}
    </ModalLayoutOld>
  );
};

export default AccountTopupLayoutOld;
